import * as React from 'react';

import { cn } from '@/utils';

const Textarea =
	/** @type {React.ForwardRefExoticComponent<React.TextareaHTMLAttributes<HTMLTextAreaElement> & React.RefAttributes<HTMLTextAreaElement>>} */ (
		React.forwardRef(({ className, ...props }, ref) => {
			return (
				<textarea
					className={cn(
						'flex min-h-[60px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-base shadow-xs placeholder:text-muted-foreground focus-visible:outline-hidden focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
						className
					)}
					ref={ref}
					{...props}
				/>
			);
		})
	);
Textarea.displayName = 'Textarea';

export { Textarea };
